import { render, staticRenderFns } from "./ExternalExperience.vue?vue&type=template&id=528eb3e2&scoped=true&"
import script from "./ExternalExperience.vue?vue&type=script&lang=js&"
export * from "./ExternalExperience.vue?vue&type=script&lang=js&"
import style0 from "./ExternalExperience.scss?vue&type=style&index=0&id=528eb3e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528eb3e2",
  null
  
)

export default component.exports